import React from "react";
import "./Produk.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Albasiaimages from "../../Media/KHI/Albasia/Albasia";
import Thompsonimages from "../../Media/KHI/Thomson/Thompson";
import Fremontimages from "../../Media/KHI/Freemont";
import Violaimages from "../../Media/KHI/Viola/Viola";
import Jasmiaimages from "../../Media/KHI/Jasmia/Jasmia";
import Laveshimages from "../../Media/KHI/Lavesh/Lavesh";
import Nishiimages from "../../Media/KHI/Nishi/Nishi";
import Hoshiimages from "../../Media/KHI/Hoshi/Hoshi";
import Teradamaiimages from "../../Media/KHI/Teradamai/Teradamai";
import Eloraimages from "../../Media/KHI/Elora/Elora";
import Nismaraimages from "../../Media/KHI/Nismara/Nismara";
import Kanaimages from "../../Media/KHI/Kana/Kana";
import Vanica9images from "../../Media/KHI/Vanica/Vanica9";

const imageMap = {
  // Add other image arrays here if you have more sets
  Albasiaimages,
  Thompsonimages,
  Fremontimages,
  Violaimages,
  Jasmiaimages,
  Laveshimages,
  Nishiimages,
  Hoshiimages,
  Teradamaiimages,
  Eloraimages,

  Nismaraimages,
  Kanaimages,
  Vanica9images,
};

const produk = () => {
  return (
    <div id="produk" className="produk">
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
